import { getJson, patchJson, postJson, deleteJson } from './authApi';
export function fetchProfile() {
    return getJson('/api/profile');
}
export function updateProfile(payload) {
    return patchJson('/api/profile', payload);
}
// Unauthenticated on purpose — the token is the proof. See the handler in
// server/routes/profile.mjs.
export function confirmEmailChange(token) {
    return postJson('/api/profile/email/confirm', { token });
}
export function deleteProfile() {
    return deleteJson('/api/profile', {});
}
export function updateProfileLocale(locale) {
    return postJson('/api/profile/locale', { locale });
}
